<template>
  <div class="company-register-container">
    <form @keyup.enter="registrationCompany">
      <b-field
        label="CNPJ"
        :type="campoInvalido('cnpj', 'data') ? 'is-danger' : ''"
        :message="
          $v.data.cnpj.$error
            ? $v.data.cnpj.required
              ? 'Documento inválido'
              : 'CNPJ é um campo obrigatório'
            : ''
        "
      >
        <b-input
          maxlength="18"
          placeholder="CNPJ"
          v-mascara:documento="data.cnpj"
          :has-counter="false"
          v-model="$v.data.cnpj.$model"
        />
      </b-field>

      <b-button
        expanded
        class="register-button"
        type="is-primary"
        :loading="loading.button"
        @click.prevent.stop="registerCompany()"
        >Continuar</b-button
      >
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import { documentValidator } from '@/utils/functions';

import formValidation from '@/mixins/formulario';

export default {
  name: 'CompanyRegister',
  mixins: [formValidation],
  data() {
    const data = {
      cnpj: '',
      socialDenomination: '',
    };

    const loading = {
      button: false,
    };

    return {
      data,
      loading,
    };
  },
  validations: {
    data: {
      cnpj: { required, documentValidator },
    },
  },
  computed: {
    ...mapState('companies', ['company']),
  },
  methods: {
    ...mapActions('companies', ['createCompany']),
    ...mapActions(['login']),
    async registerCompany() {
      if (this.$v.data.$invalid) {
        this.$v.data.$touch();
        return;
      }

      this.loading.button = true;
      try {
        await this.createCompany(this.data);
        await this.login({ chooseCompany: true, companyId: this.company.id });
        this.$alerta('Cadastrada com sucesso', 'is-success');
        this.$emit('company-registered');
      } catch (error) {
        const { response } = error;
        const detailsMessage =
          response && response.data && response.data.details && response.data.details.message;

        if (
          response &&
          response.status === 400 &&
          response.data &&
          response.data.message === 'ValidationError'
        ) {
          if (detailsMessage === 'User is already a member of a buyer') {
            this.$alerta('Usuário de prefeitura não pode cadastrar empresa', 'is-danger');
            return;
          }

          if (detailsMessage === 'Seller already registered') {
            this.$alerta('Empresa já cadastrada', 'is-danger');
            return;
          }

          if (detailsMessage) {
            this.$alerta(detailsMessage, 'is-danger');
            return;
          }
        }

        this.$alerta(error.message, 'is-danger');
      } finally {
        this.loading.button = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.company-register-container {
  min-width: 80%;
}

.register-button {
  margin-top: 1.5rem;
}
</style>
